import React from "react";
import {
  ParagraphContentType,
  ParagraphTnc,
  TYPE_PARAGRAPH,
} from "../../../../components/paragraph-tnc";

import {
  IMG_PK_CONVENTIONAL_1,
  IMG_PK_CONVENTIONAL_2,
  IMG_PK_CONVENTIONAL_3,
  IMG_PK_CONVENTIONAL_4,
  IMG_PK_CONVENTIONAL_5,
  IMG_PK_CONVENTIONAL_6,
  IMG_PK_CONVENTIONAL_7,
  IMG_PK_CONVENTIONAL_8,
  IMG_PK_CONVENTIONAL_9,
  IMG_PK_CONVENTIONAL_10,
} from "../../../../assets";

import {
  tcPkConventionalLampiranPage25To36,
  tcPkConventionalPage1To18,
  tcPromotionAAD,
} from "./pk-conventional-content.data";
import { TAgentDetail } from "../../pk-pmk-tnc.screen";
import { ImageView } from "../../../../components/image-view";

export const PKConventionalContent = ({ agentDetail }: { agentDetail: TAgentDetail }) => {
  const { innerWidth } = window;

  const fontParagraph = "text-xs text-justify text-[#666666] font-semibold";
  const fontHeader = "text-sm text-justify text-[#666666] ";

  const getWidthImage = (width: number) => {
    if (width > innerWidth) {
      return innerWidth;
    } else {
      return width;
    }
  };
  return (
    <>
      <div className="px-4 py-3 text-center">
        <h1 className="text-base font-bold text-[#333333] ">PERJANJIAN KEAGENAN</h1>
        <h1 className="text-base font-bold text-[#333333] ">PT PRUDENTIAL LIFE ASSURANCE</h1>
      </div>
      <div className="px-4 ">
        <p className={fontParagraph}>
          PERJANJIAN KEAGENAN ini ("Perjanjian") dibuat oleh dan antara:
        </p>
        <div className="w-full flex flex-row mt-1 gap-1  ">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left bg-red`}>1.</p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%]  text-left`}>Nama</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            PT PRUDENTIAL LIFE ASSURANCE
          </p>
        </div>
        <div className="w-full flex flex-row gap-1">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left`}></p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%] text-left`}>Alamat</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            Prudential Tower, Jl. Jenderal Sudirman kav 79, Jakarta Selatan 12910
          </p>
        </div>
        <div className="w-full flex flex-row gap-1">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left`}></p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%] text-left`}>No. Telp</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            (021) 2995 8888
          </p>
        </div>
        <p className={fontParagraph + " ml-[6%]"}>(selanjutnya disebut sebagai "Perusahaan")</p>
        <div className="w-full flex flex-row mt-1 gap-1  ">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left bg-red`}>2.</p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%]  text-left`}>Nama</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            {agentDetail?.name || "-"}
          </p>
        </div>
        <div className="w-full flex flex-row gap-1">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left`}></p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%] text-left`}>Alamat</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            {agentDetail?.address || "-"}
          </p>
        </div>
        <div className="w-full flex flex-row gap-1">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left`}></p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%] text-left`}>No. Telp</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            {agentDetail?.phoneNumber || "-"}
          </p>
        </div>
        <p className={fontParagraph + " ml-[6%]"}>(selanjutnya disebut sebagai "Agen")</p>
        <p className={`${fontParagraph} mt-1`}>
          Perusahaan dan Agen secara bersama-sama selanjutnya dapat disebut "Para Pihak" dan secara
          sendiri-sendiri disebut "Pihak".
        </p>
        <p className={`${fontHeader} font-bold mt-1`}>BAHWA:</p>
        <p className={`${fontParagraph} mt-1 `}>
          Perusahaan bermaksud menunjuk Agen untuk melakukan pemasaran Produk Asuransi (sebagaimana
          didefinisikan di bawah ini) dan Agen bersedia untuk menerima penunjukan Perusahaan
          berdasarkan syarat-syarat dan ketentuan-ketentuan sebagaimana diatur dalam Perjanjian ini.
        </p>
        <p className={`${fontParagraph} mt-1`}>
          <b>MAKA</b>, dengan ini Para Pihak sepakat dan setuju atas syarat-syarat dan
          ketentuan-ketentuan sebagai berikut:
        </p>
        <ParagraphTnc
          content={tcPkConventionalPage1To18 as ParagraphContentType[]}
          type={TYPE_PARAGRAPH.PARAGRAPH}
        />

        <p className={`${fontHeader} mt-1`}>
          <b>Lampiran I</b>
        </p>
        <p className={`${fontHeader} mt-1`}>
          <b>
            Ketentuan Komisi untuk <i>Agency</i>
          </b>
        </p>
        <p className={`${fontParagraph} mt-1`}>
          Produk <i>Unit Link</i> Premi berkala
        </p>
        <ImageView
          src={IMG_PK_CONVENTIONAL_1}
          alt="IMG_PK_CONVENTIONAL_1"
          className={`mt-0.5`}
          style={{ width: getWidthImage(600) }}
        />
        <p className={`${fontParagraph} mt-1`}>Produk Unit Link Premi Tunggal</p>
        <ImageView
          src={IMG_PK_CONVENTIONAL_2}
          alt="IMG_PK_CONVENTIONAL_2"
          className={`mt-0.5 `}
          style={{ width: getWidthImage(500) }}
        />
        <p className={`${fontParagraph} text-[8px] text-left  mt-0.5 leading-[0.6rem]`}>
          Catatan: Komisi untuk produk baru atau manfaat tambahan lainnya akan diinformasikan
          melalui <i>Agency Update</i> atau ketentuan Perusahaan lain secara tertulis
        </p>
        <ImageView
          src={IMG_PK_CONVENTIONAL_3}
          alt="IMG_PK_CONVENTIONAL_3"
          className={`mt-1 `}
          style={{ width: getWidthImage(300) }}
        />
        <p className={`${fontParagraph} text-[8px] text-left  mt-0.5 leading-[0.6rem]`}>
          *: Komisi <i>top-up</i> Tunggal khusus untuk produk <b>PRU</b>Link Capital Account
        </p>
        <p className={`${fontHeader} mt-1`}>
          <b>Produk Konvensional Tradisional</b>
        </p>
        <div className="flex flex-row mt-1">
          <p className={`${fontParagraph}  w-[5%]`}>1.</p>
          <div className="w-[95%] ">
            <p className={`${fontParagraph}  text-left`}>
              <b>PRU</b>Critical Benefit 88
            </p>
            <ImageView
              src={IMG_PK_CONVENTIONAL_4}
              alt="IMG_PK_CONVENTIONAL_4"
              className={`mt-0.5`}
              style={{ width: getWidthImage(600) }}
            />
          </div>
        </div>
        <div className="flex flex-row mt-1">
          <p className={`${fontParagraph}  w-[5%]`}>2.</p>
          <div className="w-[95%] ">
            <p className={`${fontParagraph}  text-left`}>
              <b>PRU</b>Solusi Sehat
            </p>
            <ImageView
              src={IMG_PK_CONVENTIONAL_5}
              alt="IMG_PK_CONVENTIONAL_5"
              className={`mt-0.5`}
              style={{ width: getWidthImage(450) }}
            />
          </div>
        </div>
        <div className="flex flex-row mt-1">
          <p className={`${fontParagraph}  w-[5%]`}>3.</p>
          <div className="w-[95%] ">
            <p className={`${fontParagraph}  text-left`}>
              <b>PRU</b>Warisan
            </p>
            <ImageView
              src={IMG_PK_CONVENTIONAL_6}
              alt="IMG_PK_CONVENTIONAL_6"
              className={`mt-0.5`}
              style={{ width: getWidthImage(600) }}
            />
          </div>
        </div>
        <p className={`${fontHeader} mt-1`}>
          <b>Produk Asuransi Karyawan</b>
        </p>
        <div className="flex flex-row mt-1">
          <p className={`${fontParagraph}  w-[5%]`}></p>
          <div className="w-[95%] ">
            <ImageView
              src={IMG_PK_CONVENTIONAL_7}
              alt=""
              className="ml-[2px]"
              style={{ width: getWidthImage(448) }}
            />
          </div>
        </div>
        <div className="flex flex-row mt-1">
          <p className={`${fontParagraph}  w-[5%]`}></p>
          <div className="w-[95%] ">
            <ImageView
              src={IMG_PK_CONVENTIONAL_8}
              alt="IMG_PK_CONVENTIONAL_8"
              className={`mt-0.5`}
              style={{ width: getWidthImage(400) }}
            />
            <p
              className={`${fontParagraph} text-[8px] text-left  mt-0.5 leading-[0.6rem] ml-[2px] mb-1`}>
              Catatan: Agen bisa melakukan penurunan komisi. Untuk agen, penurunan komisi mengacu
              pada komisi dasar.
            </p>
          </div>
        </div>

        {/* LAMPIRAN II */}

        <p className={`${fontHeader} mt-1.5`}>
          <b>Lampiran II</b>
        </p>
        <p className={`${fontHeader} mt-1`}>
          <b>Ketentuan Promosi</b>
        </p>
        <ImageView
          src={IMG_PK_CONVENTIONAL_9}
          alt="IMG_PK_CONVENTIONAL_9"
          className={`mt-0.5`}
          style={{ width: getWidthImage(1000) }}
        />

        <p className={`${fontParagraph} mt-1.5`}>
          Berikut adalah ketentuan-ketentuan lain yang berlaku bagi promosi AAD:
        </p>

        <ParagraphTnc
          content={tcPromotionAAD as ParagraphContentType[]}
          type={TYPE_PARAGRAPH.NUMBERING}
        />

        <p className={`${fontParagraph} mt-1`}>
          Informasi lengkap terkait Ketentuan Promosi mengacu pada <i>Agency Update</i> yang
          berlaku.
        </p>
        <p className={`${fontParagraph} mt-1`}>
          <b>
            Validasi <i>Maintenance (Maintenance of Contract – MOC)</i>
          </b>
        </p>
        <ImageView
          src={IMG_PK_CONVENTIONAL_10}
          alt="IMG_PK_CONVENTIONAL_10"
          className={`mt-0.5`}
          style={{ width: getWidthImage(900) }}
        />

        <p className={`${fontParagraph} mt-1`}>
          Ketentuan Promosi dan Validasi <i>MOC</i> dapat sewaktu-waktu berubah mengikuti ketentuan
          yang ditetapkan oleh Perusahaan melalui Peraturan Keagenan.
        </p>
        {/* LAMPIRAN III */}
        <p className={`${fontHeader} mt-1.5`}>
          <b>Lampiran III</b>
        </p>
        <p className={`${fontHeader} mt-1`}>
          <b>Syarat dan Ketentuan Perjanjian Keagenan</b>
        </p>
        <p className={`${fontHeader} mt-0.5`}>
          <b>Standar Praktik Kode Etik Agen Asuransi Jiwa</b>
        </p>
        <p className={`${fontHeader} mt-0.5`}>
          <b>LATAR BELAKANG </b>
        </p>
        <p className={`${fontParagraph} mt-1`}>
          Perusahaan menyadari pentingnya reputasi yang baik. Untuk memelihara reputasi yang baik
          dibutuhkan tanggung jawab dan profesionalisme tinggi dari setiap pelaku bisnis yang
          terlibat karena asuransi adalah bidang usaha yang berlandaskan pada kepercayaan dan
          kejujuran.
        </p>
        <p className={`${fontParagraph} mt-1`}>
          Prinsip-prinsip usaha dari Perusahaan adalah tindakan yang bertanggung jawab dengan
          integritas yang baik, patuh dengan hukum dan peraturan serta menghormati budaya dan
          tradisi masyarakat Indonesia. Agen Asuransi Jiwa Perusahaan (“Agen”) sebagai salah satu
          pelaku bisnis asuransi yang berpengaruh terhadap reputasi Perusahaan harus dilengkapi
          dengan suatu Kode Etik dan Perilaku untuk menghindari benturan kepentingan, penyalahgunaan
          jabatan dan penyalahgunaan informasi.
        </p>
        <p className={`${fontParagraph} mt-1`}>
          Standar Praktik Kode Etik Agen Asuransi Jiwa ini (“Kode Etik”) ditujukan agar setiap Agen
          selalu bertindak dengan etis, konsisten dan penuh integritas sesuai dengan prinsip
          Perusahaan dalam membangun kepercayaan dari (calon) Nasabah. Yang dimaksud dengan Nasabah
          dalam Standar Praktik Kode Etik Agen Asuransi Jiwa adalah Nasabah sebagaimana
          didefinisikan dalam Perjanjian, Tertanggung Utama atau Penerima Manfaat. Selain itu,
          kepatuhan Agen terhadap hukum dan peraturan serta rasa hormat terhadap tradisi dan budaya
          Indonesia mencerminkan bahwa praktik penjualan akurat, lengkap, berimbang dan memenuhi
          etika standar. Dengan demikian Kode Etik ini wajib dipatuhi oleh setiap Agen dalam
          menjalankan profesinya.
        </p>
        <ParagraphTnc
          content={tcPkConventionalLampiranPage25To36 as ParagraphContentType[]}
          type={TYPE_PARAGRAPH.PARAGRAPH}
        />
        <div className="mt-14">
          <p className={`${fontParagraph} mt-1.5 text-end`}>PAO/PK/K/V1021</p>
        </div>
      </div>
    </>
  );
};
